import {noView} from 'aurelia-framework';
import moment from 'moment';

@noView
export class DateFormatValueConverter {
	toView(value) {
		return moment(new Date(value)).format('LL');
	}
}
